import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {Tr} from "../../../ui/SimpleTable"

import {ACCORDION_ITEMS} from "../../../utils/constants/wizard"
import EditLink from "./EditLink"
import {ParaNoMargin, Td} from "./ui/layout"

const QuestionCountValidator = ({schedule, backToRoute, ...props}) => {
  const idNamespace = id("NameValidator", props)
  const {runOnce} = schedule
  const hasDriverComment = get(schedule, "preferences.includeDriverComment")
  const questionCount = get(schedule, "preferences.questionCount")
  const hasValidationErrors = hasDriverComment ? questionCount <= 1 : questionCount <= 0

  return (
    <Tr>
      <Td isLeft>
        <ParaNoMargin bold>
          <FormattedMessage id={
            runOnce
              ? "insights.schedule.validate.questionNumber.runOnce.label"
              : "insights.schedule.validate.questionNumber.label"
          } />
        </ParaNoMargin>
      </Td>
      <Td>
        {
          hasValidationErrors
            ? <EditLink
              id={idNamespace}
              url={backToRoute}
              hash={ACCORDION_ITEMS.questionLibrary}
              queryParams={{scheduleId: schedule.id}}
              contentId="insights.schedule.validate.questionCount.errorLabel" />
            : <ParaNoMargin id={idNamespace}> {questionCount} </ParaNoMargin>
        }
      </Td>
    </Tr>
  )
}

QuestionCountValidator.propTypes = {
  schedule: PropTypes.object.isRequired,
  backToRoute: PropTypes.string.isRequired
}

export default QuestionCountValidator
